export default {
  getInstitutions(state) {
    return state.institutions;
  },
  getSkills(state) {
    return state.skills;
  },
  getSoftSkills(state) {
    return state.softSkills;
  },
  getTechnicalSkills(state) {
    return state.technicalSkills;
  },
  getCertifiedSkills(state) {
    return state.certifiedSkills;
  },
  getLanguageSkills(state) {
    return state.languageSkills;
  },

  getStatistic(state) {
    return state.statistics;
  },
};
